module.exports = __webpack_public_path__ + "img/Collins.4bbc1f3d.jpeg";